module.exports = __webpack_public_path__ + "static/media/YM59_7.96a8d6c6.jpg";